"use client";

import { useEffect, useState } from "react";

import type { TileJson } from "@/providers/maps/types";

/**
 * Fetches TileJSON from URL without auth (for public find-my-school page).
 */
export function usePublicTileJson(url: string | undefined) {
  const [tileJson, setTileJson] = useState<TileJson | undefined>(undefined);

  useEffect(() => {
    if (!url) return;

    const ac = new AbortController();

    fetch(url, { signal: ac.signal })
      .then((res) => {
        if (!res.ok) throw new Error(`TileJSON request failed: ${res.status}`);
        return res.json() as Promise<TileJson>;
      })
      .then(setTileJson)
      .catch((e: Error) => {
        if (e?.name === "AbortError") return;
        console.error(e);
      });

    return () => ac.abort();
  }, [url]);

  return tileJson;
}
